import React from 'react';
import { Provider } from 'react-redux';

import EnabledFeatures from '../types/enabled_features';
import buildStore from '../redux/store';
import { AuthState } from '../redux/slices/authState/authState';
import { initialState as initialAlertsDrawerState } from '../redux/slices/alertsDrawer/alertsDrawer';
import { initialState as initialPendingTrailEditsState } from '../redux/slices/pendingTrailEdits/pendingTrailEdits';
import { initialState as initialSearchState } from '../redux/slices/search/search';
import { initialState as initialAlertsState } from '../redux/slices/alerts/alerts';
import { initialState as initialTrailsState } from '../redux/slices/trails/trails';
import { initialState as initialAreasState } from '../redux/slices/areas/areas';
import { initialState as initialFiltersState } from '../redux/slices/filters';
import Portal from '../components/Portal';

type PortalAppProps = {
  context: AuthState;
  enabledFeatures: EnabledFeatures;
};

const PortalApp = ({ context, enabledFeatures }: PortalAppProps): JSX.Element => {
  const store = buildStore({
    alertsDrawer: initialAlertsDrawerState,
    enabledFeatures,
    alerts: initialAlertsState,
    trails: initialTrailsState,
    areas: initialAreasState,
    authState: context,
    pendingTrailEdits: initialPendingTrailEditsState,
    search: initialSearchState,
    filters: initialFiltersState
  });

  return (
    <div className="xlate-none">
      <Provider store={store}>
        <Portal />
      </Provider>
    </div>
  );
};

export default PortalApp;
